<template>
    <footer class="footer py-50 py-lg-60">
        <div class="footer-bg off-area"></div>
        <v-container>
            <div class="footer__inner d-flex flex-column-reverse flex-md-row justify-space-between">
                <div class="footer__inner-bg off-area"></div>
                <div>
                    <div class="familysite-wrap mb-30 mb-lg-34">
                        <button class="familysite">
                            Family Site
                            <v-icon class="v-icon notranslate mdi mdi-chevron-down theme--light"></v-icon>
                        </button>
                        <ul class="familysite-list">
                            <li>
                                <a href="https://supportworks.kr/" target="_blank"> 서포트웍스 </a>
                            </li>
                        </ul>
                    </div>
                    <!-- <div class="d-flex mb-8 mb-lg-26">
                        <a href="" class="font-size-12 font-size-lg-16 font-weight-bold d-block mr-8 mr-md-16 mr-lg-38">
                            이용약관
                        </a>
                        <a href="" class="font-size-12 font-size-lg-16 font-weight-bold d-block mr-8 mr-md-16 mr-lg-38">
                            개인정보처리방침
                        </a>
                        <a href="" class="font-size-12 font-size-lg-16 font-weight-bold d-block mr-8 mr-md-16 mr-lg-38">
                            이메일집단수집거부
                        </a>
                        <a href="/recruitment" class="font-size-12 font-size-lg-16 font-weight-bold d-block">
                            인재채용
                        </a>
                    </div> -->
                    <p class="footer__info color-grey-5 line-height-18 font-size-12 font-size-lg-14">
                        세일즈웍스 코리아<span class="d-none d-lg-inline-block text-center w-20px">|</span><br class="d-block d-lg-none" />
                        서울시 서초구 강남대로 186 4층<span class="d-none d-lg-inline-block text-center w-20px">|</span><br class="d-block d-lg-none" />
                        대표전화 02-1600-3939<span class="d-none d-lg-inline-block text-center w-20px">|</span><br class="d-block d-lg-none" />
                        팩스 02-558-2320 <br />
                        Ⓒ 2022 SalesWorks Korea. All right reserved.
                    </p>
                </div>
                <div class="off-area">
                    <v-img src="/images/ci2.svg" max-width="118" class="mt-lg-28 mb-30 mb-md-0 footer-logo"></v-img>
                </div>
            </div>
        </v-container>
    </footer>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
    computed: {},
    mounted() {
        this.init();
    },
    methods: {
        init: function () {
            // familySite
            var familySite = document.querySelector(".familysite");
            familySite.addEventListener("click", familySiteBox);

            var offArea = document.querySelectorAll(".off-area");
            offArea.forEach(function (el) {
                el.addEventListener("click", familySiteBoxOff);
            });
        },
    },
};

function familySiteBox() {
    var familySiteWrap = document.querySelector(".familysite-wrap");
    familySiteWrap.classList.add("active");
}

function familySiteBoxOff() {
    var familySiteWrap = document.querySelector(".familysite-wrap");
    familySiteWrap.classList.remove("active");
}
</script>

<style scoped>
.footer {
    position: relative;
    background-color: #f8f8f8;
    border-top: 3px solid var(--v-primary-base);
}
.footer__inner {
    position: relative;
}
.footer-bg,
.footer__inner-bg {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0;
}
.footer .container {
    position: relative;
    max-width: calc(var(--container-lg) + 24px);
}

.familysite-wrap {
    position: relative;
    width: fit-content;
}

.familysite {
    position: relative;
    width: 200px;
    height: 36px;
    color: #777;
    font-size: 1.4rem;
    text-align: left;
    background-color: #fff;
    border: 1px solid var(--input-border-color);
    padding: 0 12px;
    transition: 0.15s ease-out;
}

.familysite:hover {
    border: 1px solid var(--input-border-hover);
}

.familysite > .v-icon {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%) rotate(0);
    color: #777;
    transition: 0.25s ease-out;
}

.familysite-wrap.active .familysite > .v-icon {
    transform: translateY(-50%) rotate(-180deg);
}

.familysite-list {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    background-color: #fff;
    padding: 8px 0;
    box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%);
    transition: 0.25s ease-out;
    opacity: 0;
    visibility: hidden;
}
.familysite-wrap.active .familysite-list {
    opacity: 1;
    visibility: visible;
}
.familysite-list a {
    display: flex;
    padding: 10px 12px;
    font-size: 1.4rem;
    line-height: 1.4;
    color: #555 !important;
}
.familysite-list a:hover {
    background-color: #f7f7f7;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .familysite {
        width: 160px;
    }
}
@media (min-width: 1024px) {
    .footer {
        border-top: 6px solid var(--v-primary-base);
    }
    .familysite {
        height: 40px;
        padding: 0 20px;
    }
    .familysite > .v-icon {
        right: 20px;
    }
}
@media (min-width: 1200px) {
}
</style>
